import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useWebSocketStore = defineStore('webSocket', () => {
  const isWebSocketSupported = ref(true) // si le WebSocket fonctionne
  const isConnected = ref(false) // si connecté au socket
  const isHttpFallback = ref(false) // si fallback HTTP activé
  const modalAlreadyShown = ref(false) // anti-spam modal

  function setWebSocketSupported(value: boolean) {
    isWebSocketSupported.value = value
  }

  function setConnected(value: boolean) {
    isConnected.value = value
  }

  function enableHttpFallback() {
    isWebSocketSupported.value = false
    isConnected.value = false
    isHttpFallback.value = true
  }

  function markModalAsShown() {
    modalAlreadyShown.value = true
  }

  function checkWebSocketSupport() {
    try {
      if ('WebSocket' in window) {
        isWebSocketSupported.value = true
        return true
      } else {
        enableHttpFallback()
        return false
      }
    } catch (err) {
      enableHttpFallback()
      return false
    }
  }

  return {
    isWebSocketSupported,
    isConnected,
    isHttpFallback,
    modalAlreadyShown,
    setWebSocketSupported,
    setConnected,
    enableHttpFallback,
    markModalAsShown,
    checkWebSocketSupport,
  }
})
